import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import { TimePicker as AntdTimePicker } from 'antd';

const GlobalStyle = createGlobalStyle`
  .ant-picker {
    padding: 0 10px 0 0;
    .ant-picker-input > input {
      padding-left: 10px;
      font-weight: 400;
      font-size: 16px;
      height: 34px;
    }
  }
  .ant-time-picker-input > input:disabled {
    background-color: #f7f7f7;
    opacity: 1;
    cursor: not-allowed;
    color: rgba(0, 0, 0, 0.25);
  }
`;

const TimePicker = ({ useBodyAsParent, ...rest }) => {
  const { fullScreen } = useSelector(state => state.planningBoard);
  return (
    <>
      <GlobalStyle />
      <AntdTimePicker
        getPopupContainer={triggerNode => useBodyAsParent && !fullScreen ?
          document.body :
          triggerNode.parentNode
        }
        {...rest}
      />
    </>
  );
};

TimePicker.propTypes = {
  useBodyAsParent: PropTypes.bool,
};

export default TimePicker;
